export const isParcelTrackingCode = (trackingNumber) => trackingNumber?.toString().startsWith("DBRPST");
